import { render, staticRenderFns } from "./Settings-grade.vue?vue&type=template&id=5f715b33&scoped=true&"
import script from "./Settings-grade.vue?vue&type=script&lang=js&"
export * from "./Settings-grade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f715b33",
  null
  
)

export default component.exports